import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmTableTh',
  props: {
  /**
   * Массив с ширинами колонок
   */
  columns: { type: Array as PropType<String[]>, default: () => [] },
  /**
   * Отключить или включить бордер слеа ячейки
   */
  isLeftBorder: { type: Boolean as PropType<Boolean>, default: true },
},
  setup(__props) {

const props = __props;

const $el = ref<HTMLElement>();


/**
 * Стили
 */
const style = computed(() => {
  return { gridTemplateColumns: props.columns.toString().replaceAll(",", " ") };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-grid-th", { 'table-grid-th--left-border': props.isLeftBorder }]),
    ref_key: "$el",
    ref: $el,
    style: _normalizeStyle(style.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})